import * as React from "react";
import {Form, Input, Row, Col} from "antd";
import {Image} from "@models/image";
import ImagePicker from '@components/custom/imagePicker';
import TextEditor, {TextEditorRef} from "@components/custom/TextEditor";
import {FormattedMessage} from 'react-intl';
import {ApplicationState} from "@reducers/index";
import {createRequest, updateRequest, fetchItemRequest} from "@actions/people";
import {Person} from "@models/person";
import {WrappedFormUtils} from 'antd/lib/form/Form';
import peopleApi from '@api/person'
import withFormWrapper from "../../hocs/withFormWrapper";

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type PersonFormAllProps = PropsFromDispatch & {
  btnText: string
  person: Person | null,
  toggleButton: Element,
  form: WrappedFormUtils
}


interface PersonFormStateShape extends Person {
  visible: boolean;
}


class PersonForm extends React.Component<PersonFormAllProps, PersonFormStateShape> {
  
  private textEditorRef = React.createRef<TextEditorRef>();
  
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      ...this.getStateFromProps(props.person),
    };
  }
  
  getStateFromProps = (person: Person | null): object => {
    const obj = person || {};
    return {
      name: obj.name || "",
      name_en: obj.name_en || "",
      slug: obj.slug || "",
      summary: obj.summary || "",
      avatar_image: obj.avatar_image || null,
      cover_image: obj.cover_image || null,
      id: obj.id,
    }
  };
  
  fetchItem = () => {
    peopleApi.getItem({
        params: {
          id: this.state.id,
        }
      })
      .then(({data}) => {
        const obj = this.getStateFromProps(data);
        this.setState(obj);
      })
      .catch((error) => console.log(error))
  };
  /**
   * Set cover and avatar ids in a form values to handle validation by form
   */
  getValues = () => {
    let returnValues = null;
    
    this.props.form.setFieldsValue({
      "cover_image_id": this.state.cover_image ? this.state.cover_image.id : "",
      "avatar_image_id": this.state.avatar_image ? this.state.avatar_image.id : "",
    });
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          summary: this.textEditorRef.current ? this.textEditorRef.current.value : "",
        }
      }
    });
    
    return {
      payload: returnValues,
      id: this.props.person ? this.props.person.id : null
    };
  };
  
  setCoverImage = (image: Image) => {
    this.setState({
      cover_image: image
    })
  };
  
  setThumbnailImage = (image: Image) => {
    this.setState({
      avatar_image: image
    })
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={'person-form'}>
        <Row gutter={8}>
          <Col span={8}>
            <Form.Item className={'no-label'}>
              {getFieldDecorator("avatar_image_id", {
                rules: [{
                  // whitespace: true,
                  message: <FormattedMessage id="app.avatar_image_is_required"
                                             defaultMessage={`Avatar image is required!`}/>
                }]
              })(
                <ImagePicker onSelectImage={this.setThumbnailImage} selectedImage={this.state.avatar_image}>
                  <div className={`image-wrapper`}
                       style={{backgroundImage: `url(${this.state.avatar_image ? this.state.avatar_image.path : ""})`}}>
                    <FormattedMessage id="app.avatar_image" defaultMessage={`Avatar Image`}/>
                  </div>
                </ImagePicker>
              )}
            </Form.Item>
          </Col>
          
          <Col span={16} className={"cover-wrapper person-cover-wrapper"}>
            <Form.Item className={'no-label'}>
              {getFieldDecorator("cover_image_id", {
                rules: [{
                  // whitespace: true,
                  message: <FormattedMessage id="app.cover_image_is_required"
                                             defaultMessage={`Cover image is required!`}/>
                }]
              })(
                <ImagePicker onSelectImage={this.setCoverImage} selectedImage={this.state.cover_image}>
                  <div className={`image-wrapper`}
                       style={{backgroundImage: `url(${this.state.cover_image ? this.state.cover_image.path : ""})`}}>
                    <FormattedMessage id="app.cover_image" defaultMessage={`Cover Image`}/>
                  </div>
                </ImagePicker>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.name" defaultMessage={`Name`}/>}>
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.name_is_required"
                                             defaultMessage={`Name is required`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
      
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.english_name" defaultMessage={`English Name`}/>}>
              {getFieldDecorator("name_en", {
                initialValue: this.state.name_en,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.english_name_is_required"
                                             defaultMessage={`English name is required`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
       
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.slug" defaultMessage={`Slug`}/>}>
              {getFieldDecorator("slug", {
                initialValue: this.state.slug,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.slug_is_required"
                                             defaultMessage={`Slug is required`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
      
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.summary" defaultMessage={`Summary`}/>}>
              {getFieldDecorator("summary", {
                initialValue: this.state.summary,
              })(
                <TextEditor ref={this.textEditorRef} text={this.state.summary}/>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(Form.create({name: "person-form"})(PersonForm))
